import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/land/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: ""
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  if (typeof to.meta.title === "string" && to.meta.title.trim()) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
